import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getList,
  getVolume,
  fetch,
  createVolume,
  calcVolumeDownloads,
  calcVolumeUploads,
  updateVolume,
};

let g_volumeList: any = null;

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function isReady() {
  return true;
}
function getList() {
  return g_volumeList;
}
function getVolume(volume_id: number) {
  return g_volumeList && g_volumeList.find((v) => v.volume_id === volume_id);
}

function fetch(done?: (err: any) => void) {
  const opts = {
    url: `/api/1/volume`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('VolumeStore.fetch: err:', err);
    } else if (body) {
      if (!util.deepEqual(g_volumeList, body.volume_list)) {
        g_volumeList = body.volume_list;
        _emit('update');
      }
    }
    if (done) {
      done(err);
    }
  });
}
function createVolume(params: any, done: (err: any) => void) {
  const { org_id, volume_name, is_media_volume } = params;
  const opts = {
    url: `/api/1/volume`,
    body: {
      org_id,
      volume_name,
      is_media_volume,
    },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('VolumeStore.createVolume: err:', err);
      done(err);
    } else if (body) {
      fetch(done);
    }
  });
}
function calcVolumeDownloads(params: any, done: (err: any) => void) {
  const { volume_id } = params;
  const opts = {
    url: `/api/1/device_hash_admin/calc_downloads/${volume_id}`,
    timeout: 5 * 60 * 1000,
  };
  UserStore.post(opts, (err) => {
    if (err) {
      util.errorLog('VolumeStore.calcVolumeDownloads: err:', err);
    }
    done(err);
  });
}
function calcVolumeUploads(params: any, done: (err: any) => void) {
  const { volume_id } = params;
  const opts = {
    url: `/api/1/device_hash_admin/calc_uploads/${volume_id}`,
    timeout: 5 * 60 * 1000,
  };
  UserStore.post(opts, (err) => {
    if (err) {
      util.errorLog('VolumeStore.calcVolumeUploads: err:', err);
    }
    done(err);
  });
}
function updateVolume(params: any, done: (err: any) => void) {
  const { volume_id, ...body } = params;
  const opts = {
    url: `/api/1/volume/${volume_id}`,
    body,
  };
  UserStore.post(opts, (err) => {
    if (err) {
      util.errorLog('VolumeStore.updateVolume: err:', err);
    }
    done(err);
  });
}
